<template>
  <div class="refugio col m-auto px-2">
    <div class="cabecera d-flex justify-content-between
        align-items-start align-content-strech">
      <h5>{{ seleccionado.name }}</h5>
      <span @click="borrar" class="remover-refugio"><i class="fa fa-trash"></i></span>
    </div>
    <button
        class="btn btn-block btn-success mb-2"
        @click.stop="addDate"
    >
      Agregar fecha
    </button>
    <vc-date-picker class="m-auto" v-if="cargado"
                    :value="null"
                    :attributes="printDates"

                    @dayclick="fechaSeleccionada"
                    :min-date="minDate"
                    ref="calendario">
      <template>
        <div class="d-flex flex-row flex-wrap mb-3 justify-content-center px-0">
          <button v-for="(date, idx) in currentDates" :key="idx"
                  :class="`btn p-2 m-1 fecha col-5 mb-1 d-flex flex-row ${date.estilo}`"

          > {{date.fecha | fechaEs}}
            <span class="align-self-end ml-2" @click="removeDate(date)">
              &nbsp;&nbsp;<i class="fa fa-times-circle"></i>
            </span>
          </button>

        </div>
      </template>
    </vc-date-picker>

  </div>
</template>

<script>
import moment from "moment";
//import {EventBus} from "../helpers/event-bus";

export default {
  name: "Refugio",
  props: {
    seleccionado: Object
  },
  data() {
    return {
      minDate: null,
      cargado: false,
      bloqueadas: [],
      guardados: []
    }
  },
  created() {
    this.entrada = moment(this.$store.state.cuaderno.entrada);
    this.minDate = this.entrada.toDate();
    this.$store.state.cuaderno.diasEscogidos.forEach(fecha => this.bloqueadas.push(moment(fecha)));
    this.cargado = true;
  },
  computed: {
    printDates() {
      let customDates = [
        {
          key: 'cerrado',
          highlight: {
            color:'red',
            fillMode: 'solid',
            style: {
              borderRadius: '5px'
            }
          },
          dates: []
        },
        {
          key: 'online',
          highlight: {
            color:'orange',
            fillMode: 'solid',
            style: {
              borderRadius: '5px'
            }
          },
          dates: []
        },
        {
          key: 'guardado',
          highlight: {
            color:'blue',
            fillMode: 'solid',
            style: {
              borderRadius: '5px'
            }
          },
          dates: []
        },
        {
          key: 'abierto',
          highlight: {
            color:'green',
            fillMode: 'solid',
            style: {
              borderRadius: '5px'
            }
          },
          dates: []
        },
        {
          key: 'seleccionado',
          highlight: {
            color:'green',
            fillMode: 'solid',
            class: 'italic',
            style: {
              borderRadius: '5px'
            }
          },
          dates: []
        },
      ];

      Object.keys(this.seleccionado.calendario).forEach( fecha => {
        switch (true) {
          case (this.seleccionado.calendario[fecha].cerrado === true):
          case this.$store.state.cuaderno.diasEscogidos.includes(fecha):
            this.bloqueadas.push(fecha);
            customDates[0].dates.push(fecha);
            break;
          case this.seleccionado.calendario[fecha].online === true:
            this.bloqueadas.push(fecha);
            customDates[1].dates.push(fecha);
            break;
          case this.seleccionado.calendario[fecha].guardado === false:
            customDates[2].dates.push(fecha);
            break;
          default:
            customDates[3].dates.push(fecha);
            break;
        }

      });
      return customDates;
    },
    currentDates() {
      let currents = [];
      this.seleccionado.fechas.forEach( fecha => {
        switch (true) {
          case this.seleccionado.calendario[fecha].guardado === false:
            currents.push({fecha, estilo:'btn-info'});
            break;
          default:
            currents.push({fecha, estilo: 'btn-success'});
            break;
        }
      });
      currents = currents.sort((a, b) =>
          moment(a.fecha).diff(moment(b.fecha), 'days')
      );
      return currents;
    },
  },
  methods: {
    fechaSeleccionada(date) {
      const fecha = moment(date.date);

      if(!this.bloqueadas.includes(fecha.format('Y-MM-DD'))) {
        this.$emit('seleccionDia', this.seleccionado, fecha.format('Y-MM-DD'));
      }

    },
    addDate() {
      const calendar = this.$refs.calendario;
      calendar.showPopover();
    },
    removeDate(date) {
      const s = moment(date.fecha);
      this.$emit('seleccionDia', this.seleccionado, s.format('Y-MM-DD'));
    },

    borrar() {
      this.$emit('remover');
    }
  }
}
</script>

<style >
.refugio,
.refugio + span {
  color: white;
  max-width: 320px !important;
  width: 320px !important;
  background-color: transparent;
  border: 1px solid #2f83b8;
  border-radius: 1rem;
  padding: .5rem;
}

button.fecha {
  font-size: 1rem;
}

.remover-refugio:hover {
  cursor: pointer;
  color: red;
}
.italic {
  background: repeating-linear-gradient(
      -45deg,
      darkgreen,
      green 5px,
      darkgreen 15px
  );
}
</style>